import { db } from "./firebase";
import {
  collection, addDoc, getDocs, updateDoc, deleteDoc,
  doc, query, where, orderBy, serverTimestamp
} from "firebase/firestore";

const COL = "claims";

export async function createClaim(data) {
  return await addDoc(collection(db, COL), {
    customerEmail: data.customerEmail.toLowerCase().trim(),
    customerName:  data.customerName,
    packageId:     data.packageId || "",
    type:          data.type,       // "not_received" | "not_delivered" | "damaged" | "other"
    description:   data.description,
    status:        "Open",          // "Open" | "In Review" | "Resolved" | "Rejected"
    adminNotes:    "",
    createdAt:     serverTimestamp(),
    updatedAt:     serverTimestamp(),
  });
}

export async function getCustomerClaims(email) {
  const q = query(
    collection(db, COL),
    where("customerEmail", "==", email.toLowerCase().trim()),
    orderBy("createdAt", "desc")
  );
  const snap = await getDocs(q);
  return snap.docs.map(d => ({ id: d.id, ...d.data() }));
}

export async function getAllClaims() {
  const q    = query(collection(db, COL), orderBy("createdAt", "desc"));
  const snap = await getDocs(q);
  return snap.docs.map(d => ({ id: d.id, ...d.data() }));
}

export async function updateClaim(id, status, adminNotes) {
  await updateDoc(doc(db, COL, id), {
    status,
    adminNotes: adminNotes || "",
    updatedAt:  serverTimestamp(),
  });
}

export async function deleteClaim(id) {
  await deleteDoc(doc(db, COL, id));
}
